import React from 'react';
import { Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  icon: '🌍',
  title: 'Cómo Conseguir Trabajo en Charter Internacional™',
  description: 'El paso a paso para entrar al mundo charter y conseguir tu primer trabajo sin perder tiempo ni cometer errores.'
}, {
  icon: '⚓',
  title: 'Qué Vas a Hacer Realmente a Bordo™',
  description: 'Descubrí cómo es la vida real en charter antes de subirte y evitá errores desde el primer día.'
}, {
  icon: '📋',
  title: 'Charter Toolkit™',
  description: 'Checklists, plantillas y sistemas listos para aplicar y trabajar con orden desde el inicio.'
}];
export function BonusSection() {
  return <section className="py-8 md:py-14 bg-navy-950 relative" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-2">
        <div className="text-center mb-6 md:mb-10" data-id="element-3">
          <div className="inline-flex items-center justify-center gap-2 md:gap-3 bg-red-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-base md:text-xl mb-4 md:mb-6 shadow-[0_0_30px_rgba(220,38,38,0.3)] animate-pulse" data-id="element-4">
            <Gift className="w-5 h-5 md:w-6 md:h-6" data-id="element-5" />Y ADEMÁS… RECIBÍS ESTOS
            BONUS EXCLUSIVOS
          </div>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-6">
          {bonuses.map((bonus, index) => <div key={index} className="bg-navy-900 rounded-2xl border border-gold-500/30 overflow-hidden shadow-2xl relative" data-id="element-7">
              <div className="p-4 md:p-6" data-id="element-8">
                <div className="flex items-start gap-3" data-id="element-9">
                  <span className="text-2xl md:text-3xl bg-navy-800 p-2 md:p-3 rounded-xl border border-navy-700" data-id="element-10">
                    🎁
                  </span>
                  <div data-id="element-11">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-12">
                      <h3 className="text-base md:text-xl font-heading font-bold text-white" data-id="element-13">
                        BONUS {index + 1} — {bonus.icon} {bonus.title}
                      </h3>
                      <span className="bg-red-600 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 md:px-3 md:py-1 rounded-full shadow-lg whitespace-nowrap" data-id="element-14">
                        GRATIS POR HOY
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-slate-300 leading-relaxed" data-id="element-15">
                      {bonus.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* Cierre de sección */}
        <div className="mt-6 md:mt-10 text-center space-y-4 md:space-y-6" data-id="element-16">
          <div className="space-y-2" data-id="element-17">
            <p className="text-base md:text-lg text-slate-300" data-id="element-18">
              No es solo información.
            </p>
            <p className="text-lg md:text-xl font-bold text-white" data-id="element-19">
              👉 Es el sistema completo para entrar, adaptarte y trabajar como
              profesional en charter.
            </p>
          </div>

          <blockquote className="text-lg md:text-2xl font-heading font-bold text-gold-400 italic" data-id="element-20">
            "No solo vas a entender cómo funciona…
            <br data-id="element-21" />
            vas a saber exactamente qué hacer."
          </blockquote>

          <CTAButton data-id="element-22" />
        </div>
      </div>
    </section>;
}